/* unplugin-vue-components disabled */import script from "./note-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./note-list.vue?vue&type=script&setup=true&lang=ts"

import "./note-list.vue?vue&type=style&index=0&id=6c09d44e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c09d44e"]])

export default __exports__